import { ApiTransaction } from '../../../openapi';
import { memo } from 'react';
import { useTransactionCategoryUtils } from '../../Transaction/useTransactionCategory';
import { useTranslation } from 'react-i18next';

export const TransactionLabel = memo(function TransactionLabel({ trx }: { trx: ApiTransaction }) {
  const { t } = useTranslation();
  const { getTransactionCategoryLabel } = useTransactionCategoryUtils();

  switch (trx.type) {
    case 'OWN_TRANSFER_IN':
      if (trx.fx) {
        return t('Exchange');
      }

      return t('Own transfer');
    case 'FEE_OUT':
    case 'FEE_OUT_INVOICE_PAYMENT':
      return t('Fee');
    case 'REWARD_IN':
      return t('Reward');
    case 'CARD_PAYMENT_OUT':
      return t('Card payment');
    case 'CARD_DEPOSIT_IN_CARD_REFUND':
      return t('Card refund');
    case 'CARD_ATM_WITHDRAWAL_OUT':
      return t('ATM withdrawal');
    case 'CARD_ATM_DEPOSIT_IN':
      return t('ATM deposit');
    case 'EXTERNAL_INCOMING_TRANSFER_IN':
      return t('Incoming transfer');
    case 'INTERNAL_OUTGOING_TRANSFER_IN_VAULT_DEPOSIT':
      return t('Vault deposit');
    case 'INTERNAL_INCOMING_TRANSFER_IN_VAULT_WITHDRAWAL':
      return t('Vault withdrawal');
    default:
      return getTransactionCategoryLabel(trx.category);
  }
});
